/* eslint-disable max-len */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

const PineappleStudiesData = (props) => {
  return (
    <Box alignItems={{md: 'center'}}>
      <div style={{fontFamily: 'Arial, sans-serif', color: '#333', margin: '20px', padding: '0'}}>
        <p>
        Greetings, weary traveler! You’ve stumbled upon the most groundbreaking, earth-shattering, mind-bending, completely amazing website in the entire multiverse.
        Here, at the Institute of Intergalactic Pineapple Studies, we’re committed to answering life’s most important questions:
        </p>

        <ul>
          <li>Is it possible for a pineapple to achieve sentience?</li>
          <li>Why do pineapples never win marathons?</li>
          <li>Does a pineapple dream of electric coconuts?</li>
        </ul>

        <p>
        We believe the universe is a pineapple-shaped enigma waiting to be unpeeled. Sure, there are those who say, “Why study pineapples when there are more important things
        like quantum physics, dark matter, or how to properly fold a fitted sheet?” But to them, we say, “What’s the point of folding a fitted sheet when pineapples exist?”
        </p>

        <h2 style={{color: '#FF6347'}}>Our Mission</h2>
        <p>
        Our state-of-the-art Pineapple Labs™ are located in a secret facility deep inside the Bermuda Triangle, which we navigated using only the stars and Google Maps (it was mostly Google Maps).
        Here, our team of highly-trained pineappleologists spends 25 hours a day—yes, we invented an extra hour—studying the intricate relationship between pineapples and their environment.
        What we’ve discovered will blow your socks off, assuming you’re wearing socks. If not, please put some on for safety.
        </p>

        <h2 style={{color: '#FF6347'}}>Breaking Pineapple News</h2>
        <ul>
          <li>Recent studies show that pineapples, when exposed to smooth jazz, grow 17% juicier. Coincidence? We think not.</li>
          <li>One rogue pineapple was recently caught attempting to start its own reality TV show. Early reviews call it <i>The Real Fruits of Tropicana</i>. Negotiations are underway.</li>
          <li>Our latest research suggests pineapples are the key to unlocking the mysteries of the universe. Einstein would have been jealous (probably).</li>
        </ul>

        <h3 style={{color: '#FF6347'}}>Pineapple Fun Facts</h3>
        <div style={{backgroundColor: '#FFFFE0', padding: '10px', border: '1px solid #FF6347', marginTop: '10px'}}>
          <ul>
            <li>Pineapples were the original inventors of Wi-Fi. You didn’t know that? Exactly.</li>
            <li>They are bilingual, fluent in both English and Morse code, but only on Wednesdays.</li>
            <li>The spikes on a pineapple’s skin were actually designed by a bored porcupine on vacation.</li>
          </ul>
        </div>

        <h2 style={{color: '#FF6347'}}>Get Involved!</h2>
        <p>
        Join the movement! For just 3 easy payments of $19.99, you can become a certified Pineapple Ambassador. This entitles you to:
        </p>
        <ul>
          <li>A lifetime supply of air.</li>
          <li>Access to our exclusive Pineapple Enthusiast Newsletter (issued once every Halley’s Comet sighting).</li>
          <li>The satisfaction of knowing you’ve supported a cause that is, in all honesty, kind of ridiculous.</li>
        </ul>

        <p>So go ahead, grab a pineapple, sit back, and enjoy this slice of fruity nonsense. And remember, the future is bright... and probably shaped like a pineapple.</p>
        <p><em>Stay spiky, friends.</em></p>
      </div>
    </Box>
  );
};
PineappleStudiesData.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};

export default React.memo(PineappleStudiesData);
